import { createElementObject, createPathComponent, extendContext } from './core';
// import { Rectangle as LeafletRectangle } from '@anlan/gs-map';
import L from '@anlan/gs-map';
import type { LatLngBoundsExpression } from '@anlan/gs-map';
import type { LeafletContextInterface, PathProps } from './core';
const LeafletRectangle = L.Rectangle;

export interface RectangleProps extends PathProps {
    bounds: LatLngBoundsExpression
}

export const Rectangle = createPathComponent(function createRectangle({ bounds , ...options }: RectangleProps, ctx: LeafletContextInterface) {
    const rectangle = new LeafletRectangle(bounds, options);
    return createElementObject(rectangle, extendContext(ctx, {
        overlayContainer: rectangle
    }));
}, function updateRectangle(layer, props: RectangleProps, prevProps: RectangleProps) {
    if (props.bounds !== prevProps.bounds) {
        layer.setBounds(props.bounds);
    }
});
